import { FundReadyHeader } from "@/components/fundready/FundReadyHeader"
import { Button } from "@/components/ui/button"

const STATS = [
  { value: "150+", label: "Vetted lenders" },
  { value: "500+", label: "Clients funded" },
  { value: "$1 Billion", label: "Funds deployed" },
]

const MODULES = [
  {
    title: "Expectations check",
    description: "Your ask vs. what lenders will realistically approve",
  },
  {
    title: "True cost",
    description: "The real APR behind any offer you're holding",
  },
  {
    title: "Cash flow stress test",
    description: "Can your revenue absorb the payments?",
  },
  {
    title: "Funding paths",
    description: "Products your assets unlock beyond a loan or MCA",
  },
]

export function IntroStep({ onStart }: { onStart: () => void }) {
  return (
    <div>
      <FundReadyHeader />
      <div className="mx-auto flex max-w-4xl flex-col gap-6 px-8 py-16">
        <p className="text-muted-foreground text-xs font-semibold tracking-widest uppercase">
          Free funding diagnostic · 3 minutes · no credit pull
        </p>
        <h1 className="text-5xl font-extrabold tracking-tight sm:text-6xl">
          Reach your funding goals <span className="text-primary">faster.</span>
        </h1>
        <p className="text-muted-foreground max-w-xl text-lg leading-relaxed">
          Answer a few questions about your business. FundReady™ benchmarks your
          ask against real lender criteria, stress-tests the payments, and shows
          which funding paths your business actually unlocks — no credit pull,
          no obligation.
        </p>
        <div>
          <Button onClick={onStart}>Check my readiness</Button>
        </div>

        <div className="mt-[26px] flex flex-wrap gap-3">
          {STATS.map((stat) => (
            <div
              key={stat.label}
              className="shadow-fr-card rounded-xl bg-white px-5 py-[13px]"
            >
              <b className="text-fr-brand block text-[19px] font-extrabold">
                {stat.value}
              </b>
              <span className="text-fr-muted text-xs font-medium">
                {stat.label}
              </span>
            </div>
          ))}
        </div>

        <div className="mt-2 grid grid-cols-[repeat(auto-fit,minmax(180px,1fr))] gap-3">
          {MODULES.map((module) => (
            <div
              key={module.title}
              className="border-fr-border shadow-fr-soft rounded-xl border bg-white px-4 py-[14px]"
            >
              <b className="text-fr-brand-strong mb-1 block text-sm font-bold">
                {module.title}
              </b>
              <span className="text-fr-muted block text-[12.5px] leading-[1.4]">
                {module.description}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
